import { Gauge, PackageSearch, QrCode, ShieldCheck, ToggleRight, WifiOff } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Pillar = { Icon: LucideIcon; title: string; body: string };

const PILLARS: ReadonlyArray<Pillar> = [
  {
    Icon: PackageSearch,
    title: 'Stock confié suivi',
    body: "Vois en temps réel ce que chaque partenaire détient, ce qui est vendu et ce qui reste à régler ou retourner.",
  },
  {
    Icon: QrCode,
    title: 'Facture avec QR code',
    body: "Chaque facture porte un QR consultable sur web, desktop et mobile. Scan, et tu retrouves la vente, le partenaire, la garantie.",
  },
  {
    Icon: Gauge,
    title: 'Quota par partenaire',
    body: "Limite le nombre d'unités qu'un partenaire peut détenir avant de régler. Fini les ardoises qui enflent sans contrôle.",
  },
  {
    Icon: ShieldCheck,
    title: 'Garantie produit',
    body: "Associe une garantie optionnelle à un article (mois ou années). Le statut est rattaché à la facture et vérifiable au scan.",
  },
  {
    Icon: ToggleRight,
    title: 'Activable par boutique',
    body: "Le module partenaire est opt-in : tu l'actives là où tu travailles en dépôt-vente, sans gêner les autres caisses.",
  },
  {
    Icon: WifiOff,
    title: 'Hors ligne natif',
    body: "Enregistre une consignation ou un règlement au comptoir sans réseau. La réconciliation du stock se fait à la synchro.",
  },
];

export default function PartenairesPillarsV2() {
  return (
    <section className="bg-charcoal-800 py-20 text-white md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel tone="dark">Ce qu'il y a dans la boîte</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.2vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-white">
          Tes partenaires, <span className="text-lime-500">à la trace.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-200">
          Tout ce qu'il faut pour gérer le dépôt-vente comme un pro — intégré à ta caisse, ton stock
          et tes factures.
        </p>

        <div className="mt-12 grid gap-[2px] border-2 border-charcoal-700 bg-charcoal-700 sm:grid-cols-2 lg:grid-cols-3">
          {PILLARS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex min-h-[210px] flex-col gap-4 bg-charcoal-800 px-7 py-8 transition-colors duration-150 hover:bg-charcoal-900"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-lime-500 bg-charcoal-900 text-lime-500">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[20px] font-bold leading-[1.15] tracking-[-0.01em] text-white">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-200">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
